<template>
  <div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model:loading="loading"
                :finished="finished"
                finished-text="没有更多数据了"
                @load="onLoad">
        <van-cell v-for="item in tableData" :key="item.id" :value="item.createTime" is-link :to="{name:'chatmsg', params: { userName:item.activeUserName}}">
          <template #icon>
            <van-image
                round
                width="3rem"
                height="3rem"
                src="https://img01.yzcdn.cn/vant/cat.jpeg"
            />
          </template>
          <template #title>
            <div style="margin-left: 2%;">{{item.activeUserName}}</div>
          </template>
          <template #label>
            <div style="margin-left: 2%;"  v-if="item.msgType==0">{{item.message}}</div>
            <div style="margin-left: 2%;"  v-if="item.msgType==1">
              <van-image
                  width="1.5rem"
                  height="1.5rem"
                  :src="item.message"
              />
            </div>
          </template>
        </van-cell>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import {queryMsgList} from "../../api/system/sys_personcenter";
import * as Util from "../../lib/utils";

export default {
  name: "MessageList",
  data() {
    return {
      tableData: [
        {
          id:0,
          activeUserName:"111",
          sendUserName: "111",
          msgType: 0,
          message: "dsdfs",
          createTime: "10:32",
          receiveUserName: "2222"
        }
      ],
      refreshing: false,
      finished: false,
      loading: false,
      activeUserName: "",
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  mounted() {
    this.$emit("titleChange", "消息列表");
    this.activeUserName = Util.getTokenUser();
    this.getData();
  },
  methods: {
    onLoad() {
      // 加载状态结束
      queryMsgList({userName: null}, this.pagination).then(res=>{
        if (res.success){
          this.tableData.push(...res.data.records);
          this.pagination.pageNum = res.data.current + 1;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
        this.loading = false;

        this.finished = true;
      });
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.onLoad();
    },
    getData(){
      queryMsgList({userName: null}, this.pagination).then(res=>{
        if (res.success){
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current + 1;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
